module.exports = __webpack_public_path__ + "img/norway.19cc6c34.svg";